
import app from "firebase/app";
import "firebase/database";
import "firebase/storage";
import { fMayor, dias, HOY, xMeses, anoMes, colorActividad, lunesSemana, masDias, ceros, indHOY, sumHoras, idProy, indiceSemanas, idAct } from "../general";
import { Actividad, Usuario, Proyecto, ItemHora, Incidente, LogIncidente, Tarea, Permisos, Story } from "./ClasesGrales";

const firebaseConfig = {
  apiKey: "AIzaSyDDptLzOxg6D0_nABm8dt3KJKs4azHtrMU",
  authDomain: "oneshot-2c76b.firebaseapp.com",
  databaseURL: "https://oneshot-2c76b.firebaseio.com",
  projectId: "oneshot-2c76b",
  storageBucket: "oneshot-2c76b.appspot.com",
  messagingSenderId: "1047298118067",
  appId: "1:1047298118067:web:492bd4e9356d56897bfbc6",
};

class ProyectoActivo {
  constructor() {
    this.proyecto = new Proyecto();
    this.actividades = [new Actividad()];
    this.numeradorAct = 0;
    this.bajasLogica = [];
  }
  numeroActividad() {
    this.numeradorAct++;
    return this.numeradorAct;
  }

  addBajaLogica(idAct) {
    this.bajasLogica.push(idAct);
  }

}

class Firebase {
  constructor() {
    app.initializeApp(firebaseConfig);
    this.db = app.database();
    this.storage = app.storage();
    this.dataProyectos = null;
    this.dataActividades = null;
    this.dataStories = null;
    this.dataUsuarios = null;
    this.dataAcciones = null;
    this.proyectoActivo = new ProyectoActivo();
    this.dataRiesgos = null;
    this.dataCambios = null;
    this.dataIncidentes = null;
    this.dataLogIncidentes = null;
    this.dataEvaluacion = null;
    this.numeradores = null;
    this.dataKeyIndicator = null;
    this.dataHoras = null;
    this.dataRoles = null;
    this.dataCategorias = null;
    this.filtroPersonas = null;
    this.earnValue = null;
    this.horasProyecto = null;        // se carga en cargarHoras
    this.horasActividad = null        // se carga en cargarHoras
    this.horasIncidente = null        // se carga en cargarHoras
    this.horasPersona = null        // se carga en cargarHoras
    this.totalHoras = null   // se carga en cargarHoras
    this.totalHorasProyectos = null   // se carga en cargarHoras
    this.totalHorasIncidentes = null  // se carga en cargarHoras
    this.totalHorasDisponibles = null // se carga en cargarUsuarios

    this.cargarUsuarios();
    this.cargarProyectos();
    this.cargarEarnValue();
    this.cargarActividades();
    this.cargarStories();
    this.cargarAcciones();
    this.cargarRiesgos();
    this.cargarCambios();
    this.cargarIncidentes();
    this.cargarLogIncidentes();
    this.cargarEvaluacion();
    this.cargarKeyIndicator();
    this.cargarNumeradores();
    this.cargarHoras();
    this.cargarRoles();
    this.cargarCategorias();
  }

  cargarUsuarios() {
    let usuarios = [];
    let horasDisponibles = 0
    let filtrousr = { Todas: "Todas" };
    this.db.ref("/Usuarios").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        let usu = new Usuario();
        usu.inicializarConRegistroDB(snapJ[key]);
        horasDisponibles += Number(usu.horassemana)
        usuarios.push(usu);
        filtrousr[usu.nombre] = usu.id;
      }
      this.dataUsuarios = [...usuarios];
      this.filtroPersonas = { ...filtrousr };
      this.totalHorasDisponibles = horasDisponibles
      usuarios = [];
      filtrousr = {};
    });
  }

  cargarProyectos() {
    let proyArray = [];
    this.db.ref("/Proyectos").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        proyArray.push(snapJ[key]);
      }
      this.dataProyectos = [...proyArray];
      proyArray = [];
    });
    return;
  }

  cargarActividades() {
    let actArray = [];
    this.db.ref("/Actividades").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        let act = new Actividad();
        let a = snapJ[key].asignados ? snapJ[key].asignados : [];
        act.inicializarConRegistroDB(snapJ[key]); // convierte a tipo de dato Actividad para ser usado
        act.asignados = [];
        for (let u = 0; u < a.length; u++) {
          act.asignados[u] = this.usuario(a[u]);
        }
        actArray.push(act);
      }
      this.dataActividades = [...actArray];
      actArray = [];
    });
  }

  cargarAcciones() {
    let accArray = [];
    this.db.ref("/Acciones").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        accArray.push(snapJ[key]);
      }
      this.dataAcciones = [...accArray];
      accArray = [];
    });
  }

  cargarStories() {
    let stArray = [];
    this.db.ref("/Stories").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        let st = new Story();
        let s = snapJ[key].asignados ? snapJ[key].asignados : [];
        st.inicializarConRegistroDB(snapJ[key]); // convierte a tipo de dato Story 
        st.asignados = [];
        for (let u = 0; u < s.length; u++) {
          st.asignados[u] = this.usuario(s[u]);
        }
        stArray.push(st);
      }
      this.dataStories = [...stArray];
      stArray = [];
    });
  }

  cargarRiesgos() {
    let riesgos = [];
    this.db.ref("/Riesgos").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        riesgos.push(snapJ[key]);
      }
      this.dataRiesgos = [...riesgos];
      riesgos = [];
    });
  }

  cargarCambios() {
    let cambios = [];
    this.db.ref("/Cambios").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        cambios.push(snapJ[key]);
      }
      this.dataCambios = [...cambios];
      cambios = [];
    });
  }

  cargarIncidentes() {
    let incidentes = [];
    this.db.ref("/Incidentes").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        incidentes.push(snapJ[key]);
      }
      this.dataIncidentes = [...incidentes];
      incidentes = [];
    });
  }

  cargarLogIncidentes() {
    let logIncidentes = [];
    this.db.ref("/LogIncidentes").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        logIncidentes.push(snapJ[key]);
      }
      this.dataLogIncidentes = [...logIncidentes];
      logIncidentes = [];
    });
  }

  cargarNumeradores() {
    this.db.ref("/Numeradores").on("value", (snap) => {
      this.numeradores = snap.val()[0];
    });
  }

  cargarEvaluacion() {
    let evaluacion = [];
    this.db.ref("/Evaluacion").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        evaluacion.push(snapJ[key]);
      }
      this.dataEvaluacion = [...evaluacion];
      evaluacion = [];
    });
  }

  cargarKeyIndicator() {
    let kaux = {};
    this.db.ref("/KeyIndicator").on("value", (snap) => {
      let snapJ = snap.val();
      for (var proyecto in snapJ) {
        kaux[proyecto] = {};
        for (var fecha in snapJ[proyecto]) {
          kaux[proyecto][fecha] = {};
          for (var dimension in snapJ[proyecto][fecha]) {
            kaux[proyecto][fecha][dimension] = snapJ[proyecto][fecha][dimension];
          }
        }
      }
      this.dataKeyIndicator = { ...kaux };
      kaux = {};
    });
  }

  cargarHoras() {  // carga las horas en memoria y actualiza el Actual Cost del earned Value
    let haux = {};
    this.db.ref("/Horas").on("value", (snap) => {
      let snapJ = snap.val();
      for (var persona in snapJ) {
        haux[persona] = {};
        for (var semana in snapJ[persona]) {
          haux[persona][semana] = snapJ[persona][semana];
        }
      }
      this.dataHoras = { ...haux };
      haux = {};
      // actualiza Actual Cost (horas incurridas) en Earned Value y la data para reportes de capacidad 
      this.actualizarCostos();
    })
  }

  actualizarCostos() {
    // actualiza los costos (horas incurridas) en earnedValue   ( AC ).  Se invoca de cargarHoras() 
    let s1 = lunesSemana(HOY, 0).toString(); // tres ultimas semanas s1, s2, y s3 son las pasibles de modificar registro de horas
    let s2 = lunesSemana(HOY, 1).toString();
    let s3 = lunesSemana(HOY, 2).toString();
    let AC = {};

    Object.entries(this.dataHoras).forEach((h) => {
      Object.entries(h[1]).forEach((s) => {
        const [semana, reghora] = s; // reghora : id, horas[0..7], tipo
        reghora.forEach((r) => {
          if (r.tipo === "Proyecto") {
            // se actualizan las 3 ultimas semanas puesto que son las semanas que se pueden registrar horas
            if (!(idProy(r.id) in AC)) AC[idProy(r.id)] = [0, 0, 0];
            AC[idProy(r.id)][0] = semana === s1 ? (AC[idProy(r.id)][0] += sumHoras(r.horas)) : AC[idProy(r.id)][0];
            AC[idProy(r.id)][1] = semana === s2 ? (AC[idProy(r.id)][1] += sumHoras(r.horas)) : AC[idProy(r.id)][1];
            AC[idProy(r.id)][2] = semana === s3 ? (AC[idProy(r.id)][2] += sumHoras(r.horas)) : AC[idProy(r.id)][2];
          }
        });
      });
    });

    // actualizar tabla EarnedValue
    let costos = [0, 0, 0];
    for (const [proyecto, costoSemana] of Object.entries(AC)) {
      if (proyecto in this.earnValue) {
        costos = [...this.earnValue[proyecto]["AC"]];
        let indSemanaHoy = indHOY(this.earnValue[proyecto]["semana"]);
        if (indSemanaHoy > 2) costoSemana[2] += costos[indSemanaHoy - 3];
        if (indSemanaHoy > 1) costos[indSemanaHoy - 2] = costoSemana[2];
        if (indSemanaHoy > 0) costos[indSemanaHoy - 1] = costoSemana[1] + costoSemana[2];
        costos[indSemanaHoy] = costoSemana[0] + costoSemana[1] + costoSemana[2];

        this.db
          .ref("/EarnValue")
          .child(proyecto)
          .update({ AC: costos })
          .catch((e) => alert("Error actualizando costo de proyectos", e));
      }
    }
  }

  horasIncurridas(semanaInicio, semanaFin, prioridadInc, prioridadPro, persona) {
    // horas incurridas en actividades, proyectos (suma actividades) e incidentes, entre semanaIni y HOY
    // y tambien las horas planeadas desde HOY hasta semanaFin

    let { isemana, cantidadSemanas } = indiceSemanas(semanaInicio, semanaFin)
    let horasProyecto = {}
    let horasIncidente = {}
    let horasActividad = {}
    let horasPersona = {}

    let totalHoras = ceros(cantidadSemanas)
    let totalHorasProyectos = ceros(cantidadSemanas)
    let totalHorasIncidentes = ceros(cantidadSemanas)

    // inicializacion de las horas trabajadas
    Object.entries(this.dataHoras).forEach((h) => {
      if (h[0] === persona || persona === "Todas") {
        Object.entries(h[1]).forEach((s) => {  // h[1] es la lista de semanas
          const [semana, reghora] = s; // reghora : id, horas[0..7], tipo
          reghora.forEach((r) => {
            if (r.tipo === "Proyecto" && (prioridadPro === "Todos" || prioridadPro === this.proyecto(idProy(r.id)).prioridad)) {
              // cargo data horas proy y actividadees para reportes de capacidad y utilizacion
              if (semana >= semanaInicio && semana <= semanaFin && semana < lunesSemana(HOY)) {
                totalHoras[isemana[semana]] += sumHoras(r.horas)
                totalHorasProyectos[isemana[semana]] += sumHoras(r.horas)
                if (!(idProy(r.id) in horasProyecto)) horasProyecto[idProy(r.id)] = ceros(cantidadSemanas);
                horasProyecto[idProy(r.id)][isemana[semana]] += sumHoras(r.horas)
                if (!(r.id in horasActividad)) horasActividad[r.id] = ceros(cantidadSemanas);
                horasActividad[r.id][isemana[semana]] += sumHoras(r.horas)
                if (persona === "Todas") {
                  if (!(r.persona in horasPersona)) horasPersona[r.persona] = ceros(cantidadSemanas);
                  horasPersona[r.persona][isemana[semana]] += sumHoras(r.horas)
                }
              }
            }
            else {
              if (r.tipo === "Incidente" && (prioridadInc === "Todos" || prioridadInc === this.incidente(r.id).prioridad)) {
                // cargo data horas incidentes para reportes de capacidad y utlizacion
                if (semana >= semanaInicio && semana <= semanaFin && semana < lunesSemana(HOY)) {
                  totalHoras[isemana[semana]] += sumHoras(r.horas)
                  totalHorasIncidentes[isemana[semana]] += sumHoras(r.horas)
                  if (!(r.id in horasIncidente)) horasIncidente[r.id] = ceros(cantidadSemanas);
                  horasIncidente[r.id][isemana[semana]] += sumHoras(r.horas)
                  if (persona === "Todas") {
                    if (!(r.persona in horasPersona)) horasPersona[r.persona] = ceros(cantidadSemanas);
                    horasPersona[r.persona][isemana[semana]] += sumHoras(r.horas)
                  }
                }
              }
            }
          });
        });
      }
    });


    // inicializacion de las horas planeadas en proyectos a partir del lunes correspondiente a HOY
    let lunesHoy = lunesSemana(HOY)
    lunesHoy = lunesHoy > semanaInicio ? lunesHoy : semanaInicio
    let actividades = this.actividades("Todos", null, persona, lunesHoy, semanaFin, prioridadPro)
    let semanaPlan, diasPlan, horasDia, horasPlan

    actividades.forEach((a) => {
      horasDia = a.horas / dias(a.finEstimado, a.inicio)
      semanaPlan = lunesHoy

      do {
        horasPlan = 0
        diasPlan = dias(a.finEstimado, semanaPlan)
        diasPlan = diasPlan > 7 ? 7 : diasPlan
        let cantAsignados = a.asignados.length ? a.asignados.length : 1
        horasPlan = (persona === "Todas") ? Math.trunc(diasPlan * horasDia) : Math.trunc((diasPlan * horasDia) / cantAsignados)

        totalHoras[isemana[semanaPlan]] += horasPlan
        totalHorasProyectos[isemana[semanaPlan]] += horasPlan
        if (!(a.proyecto in horasProyecto)) horasProyecto[a.proyecto] = ceros(cantidadSemanas);
        horasProyecto[a.proyecto][isemana[semanaPlan]] += horasPlan

        let id = a.proyecto + "/" + a.id
        if (!(id in horasActividad)) horasActividad[id] = ceros(cantidadSemanas);
        horasActividad[id][isemana[semanaPlan]] += horasPlan

        if (persona === "Todas") {
          for (let x = 0; x < a.asignados.length; x++) {
            if (!(a.asignados[x].id in horasPersona)) horasPersona[a.asignados[x].id] = ceros(cantidadSemanas);
            horasPersona[a.asignados[x].id][isemana[semanaPlan]] += horasPlan
          }
        }

        semanaPlan = masDias(semanaPlan, 7)
      } while (semanaPlan <= a.finEstimado && semanaPlan <= semanaFin)
    })

    // inicializacion de las horas planeadas en incidentes a partir del lunes correspondiente a HOY
    // hay que considerar fecha de inicio planeado ////
    let incidentes = this.incidentes("Todos", prioridadInc, "Todos", "Todos", persona, 99, null, true)
    incidentes.forEach((i) => {
      horasDia = i.finEstimado ? i.horas / dias(i.finEstimado, i.fechaRegistro) : 0
      semanaPlan = lunesHoy

      do {
        horasPlan = 0
        diasPlan = i.finEstimado >= lunesHoy ? dias(i.finEstimado, semanaPlan) : 10 // CONTROLAR FECHA VENCIDA
        diasPlan = diasPlan > 7 ? 7 : diasPlan
        horasPlan = Math.trunc(diasPlan * horasDia)

        totalHoras[isemana[semanaPlan]] += horasPlan
        totalHorasIncidentes[isemana[semanaPlan]] += horasPlan

        if (!(i.id in horasIncidente)) horasIncidente[i.id] = ceros(cantidadSemanas);
        horasIncidente[i.id][isemana[semanaPlan]] += horasPlan

        if (persona === "Todas") {
          if (!(i.responsable in horasPersona)) horasPersona[i.responsable] = ceros(cantidadSemanas);
          horasPersona[i.responsable][isemana[semanaPlan]] += horasPlan
        }


        semanaPlan = masDias(semanaPlan, 7)
      } while (semanaPlan <= i.finEstimado && semanaPlan <= semanaFin)
    })

    this.horasProyecto = { ...horasProyecto }
    this.horasActividad = { ...horasActividad }
    this.horasIncidente = { ...horasIncidente }
    this.horasPersona = { ...horasPersona }
    this.totalHorasIncidentes = [...totalHorasIncidentes]
    this.totalHorasProyectos = [...totalHorasProyectos]
    this.totalHoras = [...totalHoras]

    return lunesSemana(HOY) < semanaInicio ? -1 : lunesSemana(HOY) > semanaFin ? -2 : isemana[lunesSemana(HOY)]
  }

  horasActividadesProyecto(proyecto) {
    //para el proyecto dado, lista de actividades con horas estimadas, incurridas, previstas incurrir a hoy
    let resultado = {}
    let thoras = 0
    let tincurridas = 0
    let tprevistas = 0

    let actividades = this.actividades(proyecto, null, "Todas", 0, 99999999, "Todos")
    actividades.forEach((a) => {
      let horasPrevistas = Math.trunc(a.horas * Number(a.progreso) / 100)
      resultado[a.id] = { id: a.id, nombre: a.nombre, horas: a.horas, horasIncurridas: 0, estado: a.estado, horasPrevistas: horasPrevistas, inicio: a.inicio, finEstimado: a.finEstimado, progreso: a.progreso }
      thoras += Number(a.horas)
      tprevistas += Number(horasPrevistas)
    })

    Object.entries(this.dataHoras).forEach((h) => {
      Object.entries(h[1]).forEach((s) => {  // h[1] es la lista de semanas
        const [semana, reghora] = s; // reghora : id, horas[0..7], tipo
        reghora.forEach((r) => {
          if (r.tipo === "Proyecto" && idProy(r.id) === proyecto) {
            if (idAct(r.id) in resultado) {
              resultado[idAct(r.id)].horasIncurridas += sumHoras(r.horas)
              tincurridas += sumHoras(r.horas)
            }
          }
        })
      })
    })

    return { resultado, thoras, tprevistas, tincurridas }
  }

  cargarRoles() {
    let roles = {};
    this.db.ref("/Roles").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        roles[key] = snapJ[key];
      }
      this.dataRoles = { ...roles };
      roles = {};
    });
  }

  cargarCategorias() {
    let cat = [];
    this.db.ref("/Categorias").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        cat.push(snapJ[key]);
      }
      this.dataCategorias = [...cat];
      cat = [];
    });
  }

  cargarEarnValue() {
    let ev = {};
    this.db.ref("/EarnValue").on("value", (snap) => {
      let snapJ = snap.val();
      for (var key in snapJ) {
        ev[key] = snapJ[key];
        if (!("EV" in snapJ[key])) {
          ev[key]["EV"] = [];
        }
        if (!("AC" in snapJ[key])) {
          ev[key]["AC"] = [];
        }
      }
      this.earnValue = { ...ev };
      ev = {};
    });
    return;
  }

  datosEV(p, cota) {
    if (!cota) cota = 6;
    if (p in this.earnValue) {
      // obtengo los valores correspondiente a las ultimas 6 semanas max
      let s2 = 0; // cota superior del slice
      for (let x = 0; x < this.earnValue[p]["semana"].length; x++) {
        if (this.earnValue[p].semana[x] === lunesSemana(HOY)) {
          s2 = x + 1;
        }
      }
      let s1 = s2 > cota ? s2 - cota : 0;
      //
      let EV = [...this.earnValue[p]["EV"].slice(s1, s2)];
      let AC = [...this.earnValue[p]["AC"].slice(s1, s2)];
      let PV = [...this.earnValue[p]["PV"].slice(s1, s2)];
      let semana = [...this.earnValue[p]["semana"].slice(s1, s2)];
      let CPI = [];
      let SPI = [];

      for (let x = 0; x < AC.length; x++) {
        CPI.push(AC[x] / PV[x]);
        SPI.push(EV[x] / PV[x]);
      }

      let min = Math.min(...EV, ...AC, ...PV);
      let max = Math.max(...EV, ...AC, ...PV);
      let minSC = Math.min(...SPI, ...CPI, 0.5);
      let maxSC = Math.max(...SPI, ...CPI, 1.5);

      return { EV, AC, PV, semana, min, max, SPI, CPI, minSC, maxSC };
    } else return { EV: [0], AC: [0], PV: [0], semana: [0], min: 0, max: 0, SPI: [0], CPI: [0], minSC: 0, maxSC: 0 };
  }

  proyectos(prioridad, semaforo) {
    let paux = [];
    this.dataProyectos.forEach((p) => {
      if ((p.prioridad === prioridad || prioridad === "Todos") && (p.estado.semaforo === semaforo || semaforo === "Todos")) paux.push(p);
    });
    return paux;
  }

  actividades(proyecto, estado, persona, inicio, fin, prioridad) {
    let aaux = [];
    estado = estado === undefined ? null : estado
    persona = persona === undefined ? "Todas" : persona
    inicio = inicio === undefined ? 20000000 : inicio
    fin = fin === undefined ? 30000000 : fin
    prioridad = prioridad === undefined ? "Todos" : prioridad

    this.dataActividades.forEach((a) => {
      if (a.proyecto === proyecto || (proyecto === "Todos" && (this.proyecto(a.proyecto).prioridad === prioridad || prioridad === "Todos"))) {
        if ((!estado && a.estado !== "eliminada") || (estado && (estado === "Todas" || estado === a.estado))) {
          if (persona === "Todas" || a.usuarioAsignado(persona)) {
            if (!(inicio > a.finEstimado || fin < a.inicio)) {
              aaux.push(a.copia());
            }
          }
        }
      }
    });
    return aaux.sort(function (a, b) {
      return a.orden - b.orden;
    });
  }

  stories(proyecto, estado, sprint, prioridad, tipo, texto) {
    let aaux = [];
    sprint = sprint === undefined ? "Todos" : sprint
    prioridad = prioridad === undefined ? "Todos" : prioridad
    tipo = tipo === undefined ? "Todos" : tipo

    this.dataStories.forEach((a) => {
      if (a.proyecto === proyecto) {
        if (estado === "Todos" || estado === a.estado) {
          if (prioridad === "Todos" || a.prioridad === prioridad) {
            if (tipo === "Todos" || a.tipo === tipo) {
              if (sprint === "Todos" || a.sprint === sprint) {
                if (a.nombre.toUpperCase().includes(texto.toUpperCase())) {
                  aaux.push({ ...a });
                }
              }
            }
          }
        }
      }
    });
    return aaux.sort(function (a, b) {
      return a.nombre > b.nombre;
    });
  }

  actualizarPuntos() {
    this.proyectoActivo.actividades.forEach(a => {
      console.log('puntos en actividad', a.id, a.puntos)
      a.puntos = 0
      a.stories.forEach(h => {
        a.puntos += Number(this.historia(h).puntos)
        console.log('puntos en actividad', a.id, a.puntos, h.puntos)
      }
      )
    })
  }

  acciones(proyecto, dimension, soloActivas) {
    let aaux = [];
    this.dataAcciones.forEach((a) => {
      if (a.proyecto === proyecto && (a.dimension === dimension || dimension === "Todas") && (!soloActivas || a.estado !== "cerrada"))
        aaux.push(a);
    });
    return aaux;
  }

  riesgos(proyecto, prioridad, soloAbiertos) {
    let raux = [];
    this.dataRiesgos.forEach((r) => {
      if ((r.prioridad === prioridad || prioridad === "Todos") && r.proyecto === proyecto && !(soloAbiertos && r.estado === "cerrado"))
        raux.push(r);
    });
    return raux;
  }

  cambios(proyecto, estado) {
    // "soloabiertos" corresponde a todos los estados menos "cerraqdo"
    let caux = [];
    this.dataCambios.forEach((c) => {
      if (c.proyecto === proyecto && (c.estado === estado || estado === "Todos" || (c.estado !== "cerrado" && estado === "soloabiertos")))
        caux.push(c);
    });
    return caux;
  }

  incidentes(tipo, prioridad, categoria, estado, persona, plazo, filtro, soloAbiertos) {
    let iaux = [];
    this.dataIncidentes.forEach((i) => {
      if (
        (!filtro || i.descripcion.toLowerCase().includes(filtro)) &&
        (i.tipo === tipo || tipo === "Todos") &&
        (i.prioridad === prioridad || prioridad === "Todos") &&
        (i.categoria === categoria || categoria === "Todos") &&
        (i.estado === estado || estado === "Todos") &&
        (i.responsable === persona || persona === "Todas") &&
        !(soloAbiertos && i.estado === "cerrado" && estado === "Todos")
      ) {
        switch (plazo) {
          case -1:
            if (i.finEstimado < HOY && i.finEstimado !== 0) iaux.push(i);
            break;
          case 0:
            if (i.finEstimado === 0) iaux.push(i);
            break;
          case 2:
            if (dias(i.finEstimado, HOY) <= 2 && i.finEstimado !== 0) iaux.push(i);
            break;
          case 14:
            if (dias(i.finEstimado, HOY) <= 14 && dias(i.finEstimado, HOY) > 2 && i.finEstimado > HOY) iaux.push(i);
            break;
          case 99: //  devuelve TODOS los incidentes independiente de "plazo"
            iaux.push(i);
            break;
          default:
            if (dias(i.finEstimado, HOY) > 14 && i.finEstimado > HOY) iaux.push(i);
            break;
        }
      }
    });
    return iaux;
  }

  proyecto(id) {
    let paux = {};
    this.dataProyectos.forEach((p) => {
      if (p.id === id)
        paux = { ...p }
    });
    return paux
  }

  incidente(id) {
    let iaux = {};
    this.dataIncidentes.forEach((i) => {
      if (i.id === id)
        iaux = { ...i }
    });
    return iaux
  }

  riesgo(id) {
    let raux = {};
    this.dataRiesgos.forEach((r) => {
      if (r.id === id)
        raux = { ...r }
    });
    return raux
  }

  accion(id) {
    let aaux = {};
    this.dataAcciones.forEach((a) => {
      if (a.id === id)
        aaux = { ...a }
    });
    return aaux;
  }

  historia(id) {
    let saux = {};
    this.dataStories.forEach((s) => {
      if (s.id === id)
        saux = { ...s }
    });
    return saux;
  }

  misTareas(usuario) {

    function clasificacion(f) {
      let p = dias(f, HOY)
      if (f === 0) return "Mediano plazo"
      if (p < 7) return "Prioritarias"
      if (p < 14) {
        return "15 dias"
      } else { return "Mediano plazo" }
    }

    function prioridad(proy, proyectos) {
      let pri
      proyectos.forEach((p) => {
        if (proy === p.id) pri = p.prioridad
      })
      return pri
    }

    if (usuario) {
      let tareas = { "Prioritarias": [], "15 dias": [], "Mediano plazo": [] }

      this.dataActividades.forEach((a) => {
        if (a.estado !== "terminada" && a.estado !== "eliminada") {
          a.asignados.forEach((u) => {
            if (u.id === usuario) {
              let tarea = new Tarea("Actividad", a.id, a.nombre, a.finEstimado, prioridad(a.proyecto, this.dataProyectos), a.proyecto);
              tareas[clasificacion(a.finEstimado)].push(tarea);
            }
          });
        }
      });

      this.dataAcciones.forEach((a) => {
        if (a.estado !== "cerrada") {
          if (a.responsable === usuario) {
            let tarea = new Tarea("Accion", a.id, a.descripcion, a.finEstimado, a.prioridad, a.proyecto);
            tareas[clasificacion(a.finEstimado)].push(tarea);
          }
        };
      });

      this.dataIncidentes.forEach((i) => {
        if (i.estado !== "cerrado") {
          if (i.responsable === usuario) {
            let tarea = new Tarea("Incidente", i.id, i.descripcion, i.finEstimado, i.prioridad, "");
            tareas[clasificacion(i.finEstimado)].push(tarea);
          }
        };
      });

      this.dataRiesgos.forEach((r) => {
        if (r.estado !== "cerrado") {
          if (r.responsable === usuario) {
            let tarea = new Tarea("Riesgo", r.id, r.descripcion, 0, r.prioridad, r.proyecto);
            tareas["Mediano plazo"].push(tarea);
          }
        };
      });
      return tareas
    }
  }

  incidentesPlan() {

    function clasificacion(f) {
      let p = dias(f, HOY)
      if (f === 0) return "Mediano plazo"
      if (p < 7) return "7 dias"
      if (p < 14) {
        return "15 dias"
      } else { return "Mediano plazo" }
    }

    let plan = {}

    this.dataIncidentes.forEach((i) => {
      if (i.estado !== "cerrado") {
        if (!plan[i.responsable]) plan[i.responsable] = { "7 dias": [], "15 dias": [], "Mediano plazo": [] }
        let grupo = clasificacion(i.finEstimado)
        plan[i.responsable][grupo].push({ ...i, grupo: grupo, cambio: false, usuarioActual: i.responsable });
      }
    })
    return plan
  }


  logIncidente(id) {
    let iaux = [];
    this.dataLogIncidentes.forEach((i) => {
      if (i.idIncidente === id) iaux.push(i);
    });
    return iaux.sort(function (a, b) {
      return b.fecha - a.fecha;
    });
  }

  datosGraficoLog(tipo, prioridad, categoria, estado, persona) {
    let titulo = "Incidentes por estado de planificación";
    let suma = 0;
    let cantidad = 5;

    let p0 = this.incidentes(tipo, prioridad, categoria, estado, persona, 0, "", true).length;
    let p2 = this.incidentes(tipo, prioridad, categoria, estado, persona, 2, "", true).length;
    let p14 = this.incidentes(tipo, prioridad, categoria, estado, persona, 14, "", true).length;
    let p15 = this.incidentes(tipo, prioridad, categoria, estado, persona, 15, "", true).length;
    let p1 = this.incidentes(tipo, prioridad, categoria, estado, persona, -1, "", true).length;
    let listaValores = [p0, p2, p14, p15, p1];
    let listaEtiquetas = ["Sin plan", "2 días", "14 días", "Mayor a 14 días", "Atrasados"];
    let listaPlazo = [0, 2, 14, 15, -1];
    suma = p0 + p2 + p14 + p15 + p1;

    return { titulo, suma, cantidad, listaValores, listaEtiquetas, listaPlazo };
  }

  datosGraficoHist(tipo, prioridad, categoria, estado, persona) {
    let maximo = 0; // se carga con el valor maximo de abiertos y cerrados para facilitar proporcion en el grafico
    let maximoAcum = 0; // se carga con el valor maximo de abiertos y cerrados (acumulados) para facilitar proporcion en el grafico
    let abiertos = [0, 0, 0, 0, 0, 0];
    let cerrados = [0, 0, 0, 0, 0, 0];
    let abiertosAcum = [0, 0, 0, 0, 0, 0];
    let cerradosAcum = [0, 0, 0, 0, 0, 0];
    let meses = xMeses(); // carga los ultimos 6 meses incluyendo el actual

    let incidentes = this.incidentes(tipo, prioridad, categoria, estado, persona, 99, "", false);
    for (let i = 0; i < incidentes.length; i++) {
      for (let m = 0; m < meses.length; m++) {
        if (anoMes(incidentes[i].fechaRegistro) === meses[m]) {
          abiertos[m]++;
          maximo = abiertos[m] > maximo ? abiertos[m] : maximo;
        }
        if (anoMes(incidentes[i].fechaRegistro) <= meses[m]) {
          abiertosAcum[m]++;
          maximoAcum = abiertosAcum[m] > maximoAcum ? abiertosAcum[m] : maximoAcum;
        }
        if (incidentes[i].fechaCierre !== 0) {
          if (anoMes(incidentes[i].fechaCierre) === meses[m]) {
            cerrados[m]++;
            maximo = cerrados[m] > maximo ? cerrados[m] : maximo;
          }
          if (anoMes(incidentes[i].fechaCierre) <= meses[m]) {
            cerradosAcum[m]++;
            maximoAcum = cerradosAcum[m] > maximoAcum ? cerradosAcum[m] : maximoAcum;
          }
        }
      }
    }

    return { maximo, abiertos, cerrados, maximoAcum, abiertosAcum, cerradosAcum, meses };
  }

  responsablesAccion(proyecto, accion) {
    let raux = [];
    for (var a = 0; a < this.dataAcciones.length; a++) {
      if (this.dataAcciones[a].proyecto === proyecto && this.dataAcciones[a].id === accion) {
        if (this.dataAcciones[a].responsables !== undefined) {
          this.dataAcciones[a].responsables.forEach((r) => raux.push(this.usuario(r)));
        }
        return raux;
      }
    }
    return raux;
  }

  usuario(id) {
    let uaux;
    this.dataUsuarios.forEach((u) => {
      if (u.id === id) uaux = u;
    });
    return uaux;
  }

  usuarioEmail(email) {
    let uaux;
    this.dataUsuarios.forEach((u) => {
      if (u.email === email) uaux = u;
    });
    return uaux;
  }

  usuarios(filtro) {
    // devuelve usuarios cuyo nombre incluye el filtro
    if (filtro === null) return this.dataUsuarios;
    let uaux = [];
    this.dataUsuarios.forEach((u) => {
      if (u.nombre.toUpperCase().includes(filtro.toUpperCase())) uaux.push(u);
    });
    return uaux;
  }

  permisos(rol) {
    if (this.dataRoles[rol]) {
      return this.dataRoles[rol];
    } else {
      return new Permisos();
    }
  }

  finMayor(proyectos) {
    let actaux = [];
    proyectos.forEach((p) => Array.prototype.push.apply(actaux, this.actividades(p.id)));
    //  devuelve fecha de fin mayor de todas las actividades de todos los proyectos
    let f = "20000101";
    actaux.forEach((a) => {
      f = fMayor(a.finEstimado, f) ? a.finEstimado : f;
    });
    return f;
  }

  inicioMenor(proyectos) {
    let actaux = [];
    proyectos.forEach((p) => Array.prototype.push.apply(actaux, this.actividades(p.id)));
    //  devuelve fecha de inicio menor de todas las actividades de todos los proyectos
    let f = "21000101";
    actaux.forEach((a) => {
      f = fMayor(f, a.inicio) ? a.inicio : f;
    });
    return f;
  }

  finProyecto(proyecto) {
    //  devuelve fecha de fin del proyecto (fecha de fin mayor de sus actividades)
    let f = "20000101";
    this.actividades(proyecto).forEach((a) => {
      f = fMayor(a.finEstimado, f) ? a.finEstimado : f;
    });
    return f;
  }

  inicioProyecto(proyecto) {
    //  devuelve fecha de inicio del proyecto (fecha de inicio menor de sus actividades)
    let f = "21000101";
    this.actividades(proyecto).forEach((a) => {
      f = fMayor(f, a.inicio) ? a.inicio : f;
    });
    return f;
  }

  marcoFechas(actividades) {
    // retorna plazo total del proyecto en dias a partir de la lista de actividades que recibe como parametro
    //(las actividades deben ser del objeto Actividad. fmenor y fmayor son las fecha de inicio y fin del proyecto)
    let fmenor = 21000000;
    let fmayor = 0;
    for (let i = 0; i < actividades.length; i++) {
      fmenor = actividades[i].inicio < fmenor ? actividades[i].inicio : fmenor;
      fmayor = actividades[i].finEstimado > fmayor ? actividades[i].finEstimado : fmayor;
    }
    let maxDias = dias(fmayor, fmenor);
    return { maxDias, fmenor, fmayor };
  }

  activarProyecto(proyecto) {
    if (proyecto) {
      this.proyectoActivo.proyecto.inicializarConRegistroDB(proyecto);
      this.proyectoActivo.actividades = [...this.actividades(proyecto.id)];
      this.proyectoActivo.numeradorAct = this.actividades(proyecto.id, "Todas").length;
    } else {
      this.proyectoActivo = new ProyectoActivo();
    }
  }

  nuevaEvaluacion(proyecto, fecha) {
    ["Alcance", "Cronograma", "Recursos"].forEach((d) => {
      let i = 0;
      this.dataEvaluacion.forEach((e) => {
        if (e.id === d) {
          this.db.ref(`/KeyIndicator/${proyecto}/${fecha}/${e.id}/${i}`).set({ ...e, evaluacion: "" });
          i++;
        }
      });
    });
  }

  evaluacion(proyecto, fecha, filtro) {
    // filtro es alcance, cronograma, recursos
    let eaux = [];
    if (proyecto) {
      this.dataKeyIndicator[proyecto][fecha][filtro].forEach((k) => {
        eaux.push(k);
      });
    }
    return eaux;
  }

  numProyecto() {
    let res = this.numeradores.proyectos;
    this.db
      .ref("/Numeradores")
      .child("0/proyectos")
      .set(this.numeradores.proyectos + 1);
    return "PR" + res.toString();
  }

  async actualizarProyectoActivo() {
    let p = this.proyectoActivo.proyecto;

    // validaciones proyect
    let hayErrores = false;
    if (p.pm === "" || p.prioridad === "") {
      alert("Seleccione el PM y/o prioridad");
      hayErrores = true;
    }
    if (p.tipo === "") {
      alert("Seleccione el tipo de proyecto");
      hayErrores = true;
    }
    if (hayErrores) return;

    // si existe actualiza, sino crea al proyecto y la evaluacion en blanco
    if (!p.id) {
      p.id = this.numProyecto();
      p.fechaEvaluacion = HOY;
      this.nuevaEvaluacion(p.id, HOY);
      // esta creando el proyecto por lo que le grabo una actividad vacia
      this.proyectoActivo.actividades[0].nombre = "...nueva"
      this.actualizarActividadesPA()
    }
    await this.db
      .ref("/Proyectos")
      .child(p.id)
      .set(p)
      .then(() => alert("Proyecto actualizado"))
      .catch((e) => alert("Error grabando Proyectos", e));
  }

  async actualizarActividadesPA() {
    // actualiza actividades del proyecto activo
    let p = this.proyectoActivo.proyecto;
    let a = this.proyectoActivo.actividades;

    // validaciones actividades
    let hayErrores = false;
    a.forEach((x) => {
      if (x.nombre === "") {
        alert("Hay actividades sin nombre");
        hayErrores = true;
      }
      if (isNaN(x.horas)) {
        alert("Hay horas con tipo de dato incorrecto");
        hayErrores = true;
      }
    });
    if (hayErrores) return;

    // si existen las actividades las actualiza, sino las crea.  Actualiza el orden en que se muestran en el crono
    a.forEach((y, i) => {
      let x = y.copia();
      x.proyecto = p.id; // vale para el caso de un proyecto nuevo ya que las actividades no lo tienen asociado aun
      x.orden = i;
      if (x.estado !== "eliminada") {
        switch (Number(x.progreso)) {
          case 0: x.estado = "pendiente"; break
          case 100: x.estado = "terminada"; break
          default: x.estado = "ejecutando"
        }
      }

      x.puntos = 0
      x.stories.forEach(h => {
        x.puntos += Number(this.historia(h).puntos)
      })

      x.color = "#A9F5BC"
      // graba solo la clave de los usuarios
      let u = x.asignados.map((u) => u.id);
      x.asignados = [...u];
      this.db
        .ref("/Actividades")
        .child(p.id + x.id)
        .set(x)
        .catch((e) => alert("Error actualizando actividades", e));

      // actualizar estado de historias de cada actividad si el estado es "...en uso..."
      x.stories.forEach(h => {
        if (this.historia(h).estado === "...en uso...") {
          this.db
            .ref("/Stories")
            .child(h)
            .update({ estado: "asignado" })
            .catch((e) => alert("Error actualizando el estado de la  historia que era ...en uso... " + e));
        }
      });
    });




    // marca bajas logicas
    this.proyectoActivo.bajasLogica.forEach((id) => {
      this.db
        .ref("/Actividades")
        .child(p.id + id)
        .update({ estado: "eliminada" })
        .then(() => (this.proyectoActivo.bajasLogica = []))
        .catch((e) => alert("Error actualizando actividades eliminadas", e));
    });

    // actualiza el earned value
    this.actualizarEarnedValue(p.id, a);
  }

  actualizarUsuario(u) {
    // si existe actualiza, sino lo crea
    u.id = u.id.toUpperCase();
    this.db
      .ref("/Usuarios")
      .child(u.id)
      .set(u)
      .then(() => alert("Usuario actualizado ", u.id))
      .catch((e) => alert("Error grabando Usuario", e));
  }

  numRiesgo() {
    let res = this.numeradores.riesgos;
    this.db
      .ref("/Numeradores")
      .child("0/riesgos")
      .set(this.numeradores.riesgos + 1);
    return "R" + res.toString();
  }

  async actualizarRiesgo(r) {
    // si existe actualiza, sino lo crea
    r.id = r.id === "...nuevo..." ? this.numRiesgo() : r.id;
    // cambio formato de fechas de YYYY-MM-DD a YYYYMMDD
    r.inicio = isNaN(r.inicio) ? 0 : r.inicio;

    await this.db
      .ref("/Riesgos")
      .child(r.id)
      .set(r)
      .then(() => alert("Riesgo actualizado ", r.id))
      .catch((e) => alert("Error grabando Riesgo", e));
  }

  numCambio() {
    let res = this.numeradores.cambios;
    this.db
      .ref("/Numeradores")
      .child("0/cambios")
      .set(this.numeradores.cambios + 1);
    return "C" + res.toString();
  }

  async actualizarCambio(c) {
    // si existe actualiza, sino lo crea
    c.id = c.id === "...nuevo..." ? this.numCambio() : c.id;
    // cambio formato de fechas de YYYY-MM-DD a YYYYMMDD
    c.inicio = isNaN(c.inicio) ? 0 : c.inicio;
    c.fechaCierre = isNaN(c.fechaCierre) ? 0 : c.fechaCierre;

    await this.db
      .ref("/Cambios")
      .child(c.id)
      .set(c)
      .then(() => alert("Cambio actualizado ", c.id))
      .catch((e) => alert("Error grabando Cambio", e));
  }

  numAccion() {
    let res = this.numeradores.acciones;
    this.db
      .ref("/Numeradores")
      .child("0/acciones")
      .set(this.numeradores.acciones + 1);
    return "A" + res.toString();
  }

  async actualizarAccion(a) {
    // si existe actualiza, sino lo crea
    a.id = a.id === "...nueva..." ? this.numAccion() : a.id;
    // cambio formato de fechas de YYYY-MM-DD a YYYYMMDD
    a.inicio = isNaN(a.inicio) ? 0 : a.inicio;
    a.finEstimado = isNaN(a.finEstimado) ? 0 : a.finEstimado;

    await this.db
      .ref("/Acciones")
      .child(a.id)
      .set(a)
      .then(() => alert("Accion actualizada ", a.id))
      .catch((e) => alert("Error grabando Accion", e));
  }

  async actualizarKeyIndicator(p, e, d) {
    if (HOY !== this.proyectoActivo.proyecto.fechaEvaluacion) {
      this.nuevaEvaluacion(p, HOY);
      this.proyectoActivo.proyecto.fechaEvaluacion = HOY;
    }
    this.db.ref(`/KeyIndicator/${p}/${HOY}/${d}`).set(e);

    // actualizar estado (color) de la dimension y del proyecto
    let total = { amarillo: 0, rojo: 0 };
    let dimension;
    let estadoActivo = this.proyectoActivo.proyecto.estado;
    e.forEach((pregunta) => {
      if (pregunta.evaluacion === "" || pregunta.evaluacion === pregunta.respuesta) {
        total[pregunta.impacto]++;
      }
    });
    dimension = total["rojo"] ? "Rojo" : !total["amarillo"] ? "Verde" : total["amarillo"] === 1 ? "Amarillo" : "Rojo";
    estadoActivo[d.toLowerCase()] = dimension;
    // actualizo semaforo
    let cantAmarillos =
      (estadoActivo["alcance"] === "Amarillo") + (estadoActivo["cronograma"] === "Amarillo") + (estadoActivo["recursos"] === "Amarillo");
    estadoActivo["semaforo"] =
      estadoActivo["alcance"] === "Rojo" ||
        estadoActivo["cronograma"] === "Rojo" ||
        estadoActivo["recursos"] === "Rojo" ||
        cantAmarillos >= 2
        ? "Rojo"
        : !cantAmarillos
          ? "Verde"
          : "Amarillo";
    this.db
      .ref("/Proyectos")
      .child(p)
      .update({ estado: estadoActivo, fechaEvaluacion: this.proyectoActivo.proyecto.fechaEvaluacion })
      .catch((e) => alert("Error actualizando estado Proyecto", e));
  }

  itemsHoras(persona, semana) {  // lista de items en los que una persona esta asignado para claimear horas en la semana
    let items = [];
    function estaEnItems(id) {
      let esta = false;
      items.forEach((i) => {
        if (i.id === id) {
          esta = true;
        }
      });
      return esta;
    }

    // cargo registro en curso
    if (this.dataHoras[persona]) {
      if (this.dataHoras[persona][semana]) {
        this.dataHoras[persona][semana].forEach((h) => {
          let item = new ItemHora(semana, persona, h.id, h.nombre, h.tipo);
          item.horas = [...h.horas];
          items.push(item);
        });
      }
    }

    // cargo actividades nuevas
    let actividades = this.actividades("Todos", null, persona, semana, masDias(semana, 7), "Todos")
    actividades.forEach((a) => {
      if (a.estado !== "terminada" && a.estado !== "eliminada") {
        let id = a.proyecto + "/" + a.id;
        if (!estaEnItems(id)) {
          let item = new ItemHora(semana, persona, id, a.nombre, "Proyecto");
          items.push(item);
        }
      }
    });

    // cargo incidentes nuevos
    this.dataIncidentes.forEach((i) => {
      if (i.estado !== "cerrado" || i.fechaCierre >= semana) {
        if (i.responsable === persona) {
          if (!estaEnItems(i.id)) {
            let item = new ItemHora(semana, persona, i.id, i.descripcion, "Incidente");
            items.push(item);
          }
        }
      }
    });
    return items;
  }

  actualizarHoras(items, persona, semana) {
    this.db
      .ref(`/Horas/${persona}/${semana}`)
      .set(items)
      .then(() => alert("Horas actualizado"))
      .catch((e) => alert("Error actualizando horas", e));
  }

  actualizarRol(rol, permisos) {
    this.db
      .ref(`/Roles/${rol}`)
      .set(permisos)
      .then(() => alert("Rol actualizado"))
      .catch((e) => alert("Error actualizando Rol", e));
  }

  actualizarCategorias(categorias) {
    this.db.ref("/Categorias").set(categorias);
  }

  actualizarEvaluacion(evaluacion) {
    this.db.ref("/Evaluacion").set(evaluacion);
  }

  numIncidente() {
    let res = this.numeradores.incidentes;
    this.db
      .ref("/Numeradores")
      .child("0/incidentes")
      .set(this.numeradores.incidentes + 1);
    return "I" + res.toString();
  }

  actualizarIncidente(i) {
    // valido que la prioridad, tipo y categoria no sea vacia
    if (!i.prioridad || !i.categoria || !i.tipo) {
      alert("La prioridad, tipo y/o categoria no pueden estar vacías");
      return;
    }
    // si existe actualiza, sino lo crea
    i.id = i.id === "...nuevo..." ? this.numIncidente() : i.id;
    // cambio formato de fechas de YYYY-MM-DD a YYYYMMDD
    i.finEstimado = isNaN(i.finEstimado) ? 0 : i.finEstimado
    i.fechaCierre = isNaN(i.fechaCierre) ? 0 : i.fechaCierre

    if (i.estado === "cerrado" && i.fechaCierre === 0) i.fechaCierre = HOY;
    if (i.fechaCierre && i.estado !== "cerrado") i.estado = "cerrado";
    if (i.finEstimado === 0) i.responsable = "ZZZ"  // asocio al "planficador"

    this.db
      .ref("/Incidentes")
      .child(i.id)
      .set(i)
      .then(() => alert("Incidente actualizado ", i.id))
      .catch((e) => alert("Error grabando Incidente", e));

    return i.id
  }

  numLogIncidente() {
    let res = this.numeradores.log;
    this.db
      .ref("/Numeradores")
      .child("0/log")
      .set(this.numeradores.log + 1);
    return "L" + res.toString();
  }

  async actualizarLogIncidente(l) {
    // si existe actualiza, sino lo crea
    l.id = l.id === "...nuevo..." ? this.numLogIncidente() : l.id;

    await this.db
      .ref("/LogIncidentes")
      .child(l.id)
      .set(l)
      .catch((e) => alert("Error grabando Log Incidente", e));
  }

  actualizarEarnedValue(p, actividades) {
    let ev = { id: p, EV: [], AC: [], PV: [], semana: [] };
    if (p in this.earnValue) {
      ev.AC = [...this.earnValue[p].AC];
      ev.EV = [...this.earnValue[p].EV];
    }

    let { fmenor, fmayor } = this.marcoFechas(actividades);
    let ind = 0;
    let indHOY = 0;
    for (let s = lunesSemana(masDias(fmenor, 7)); s < fmayor; s = masDias(s, 7)) {
      ev["semana"].push(s);
      if (!ev["EV"][ind]) ev["EV"][ind] = 0;
      if (!ev["AC"][ind]) ev["AC"][ind] = 0;
      ev["PV"][ind] = 0;
      if (s === lunesSemana(HOY, 0)) indHOY = ind;
      ind++;
    }

    ev["semana"].push(fmayor);
    if (!ev["EV"][ind]) ev["EV"][ind] = 0;
    if (!ev["AC"][ind]) ev["AC"][ind] = 0;
    ev["PV"][ind] = 0;
    ev["AC"] = ev["AC"].slice(0, ind + 1);
    ev["EV"] = ev["EV"].slice(0, ind + 1);

    let EVhoy = 0;
    actividades.forEach((a) => {
      ev["semana"].forEach((s, ind) => {
        if (a.inicio < s) {
          let avance = dias(s, a.inicio) / dias(a.finEstimado, a.inicio);
          if (avance > 1) avance = 1;
          ev["PV"][ind] += Math.trunc(a.horas * avance);
        }
        if (s === lunesSemana(HOY)) EVhoy += (a.horas * a.progreso) / 100;
      });
      ev["EV"][indHOY] = EVhoy;
    });

    this.db
      .ref("/EarnValue")
      .child(p)
      .set(ev)
      .then(() => alert("Actividades actualizadas"))
      .catch((e) => alert("Error actualizando actividades", e));
  }

  actualizarPlan(plan) {
    Object.entries(plan).forEach((p => {
      let persona = p[0]
      Object.entries(p[1]).forEach(g => {
        g[1].forEach(i => {
          if (i.usuarioActual !== i.responsable && persona === i.responsable) {
            this.db
              .ref("/Incidentes")
              .child(i.id)
              .update({ responsable: i.usuarioActual })
              .catch((e) => alert(i.id, "Error actualizando plan de incidentes", e));
          }
        })
      })
    }))
    alert('Plan de incidentes actualizado')
  }

  numStory() {
    let res = this.numeradores.historias;
    this.db
      .ref("/Numeradores")
      .child("0/historias")
      .set(this.numeradores.historias + 1);
    return "ST" + res.toString();
  }

  async actualizarHistoria(s) {
    // si existe actualiza, sino lo crea
    s.id = s.id === "...nueva..." ? this.numStory() : s.id;

    await this.db
      .ref("/Stories")
      .child(s.id)
      .set(s)
      .then(() => alert("Historia actualizada " + s.id))
      .catch((e) => alert("Error grabando historia de usuario", e));
  }

  asignarSprint(s, a, estado) {  // a es el id de la actividad (sprint),
    this.db
      .ref("/Stories")
      .child(s)
      .update({ sprint: a, estado: estado })
      .catch((e) => alert("Error actualizando el sprint de una historia " + e + s));
  }
  ///
  ///  funciones para alta batch de datos de prueba
  altaUsuarios(Usuarios) {
    this.db.ref("/Usuarios").set(Usuarios);
    return "alta usuarios";
  }

  altaActividades(Actividades) {
    let pant = "";
    let ind;
    Actividades.forEach((a) => {
      if (a.proyecto !== pant) {
        pant = a.proyecto;
        ind = 0;
      }
      ind++;
      let act = new Actividad();
      act.inicializarConRegistroDB(a);
      act.id = "ACT" + "000".slice(ind.toString().length) + ind;
      act.orden = ind;
      act.color = colorActividad[ind % colorActividad.length];
      this.db
        .ref("/Actividades")
        .child(act.proyecto + act.id)
        .set(act);
    });

    return "alta actividades";
  }

  altaStories(Stories) {
    let pant = "";
    let ind;
    Stories.forEach((s) => {
      if (s.proyecto !== pant) {
        pant = s.proyecto;
        ind = 0;
      }
      ind++;
      let st = new Story();
      st.inicializarConRegistroDB(s);
      st.id = "ST" + ind;
      this.db
        .ref("/Stories")
        .child(st.proyecto + st.id)
        .set(st);
    });

    return "alta stories";
  }

  altaAcciones(Acciones) {
    let ind = 0;
    Acciones.forEach((a) => {
      a.id = "A" + ind.toString();
      ind++;
      this.db.ref("/Acciones").child(a.id).set(a)
    });
    return "alta accciones";
  }

  altaRiesgos(Riesgos) {
    let ind = 0;
    Riesgos.forEach((r) => {
      r.id = "R" + ind.toString();
      r.responsable = ""
      r.horas = ""
      r.dimension = ""
      ind++;
      this.db.ref("/Riesgos").child(r.id).set(r)
    });
    return "alta riesgos";
  }

  altaCambios(Cambios) {
    let ind = 0;
    Cambios.forEach((c) => {
      c.id = "C" + ind.toString();
      ind++;
      this.db.ref("/Cambios").child(c.id).set(c)
    });
    return "alta cambios";
  }

  altaIncidentes(Incidentes) {
    let ind = 0;
    Incidentes.forEach((i) => {
      let inc = new Incidente();
      inc.inicializarConRegistroDB(i);
      inc.id = "I" + ind.toString();
      ind++;
      this.db.ref("/Incidentes").child(inc.id).set(inc);
    });
    return "alta incidenes";
  }

  altaLogIncidentes(LogIncidentes) {
    let ind = 0;
    LogIncidentes.forEach((i) => {
      let inc = new LogIncidente();
      inc.inicializarConRegistroDB(i);
      inc.id = "L" + ind.toString();
      ind++;
      this.db.ref("/LogIncidentes").child(inc.id).set(inc);
    });
    return "alta Log incidenes";
  }

  altaNumeradores(Numeradores) {
    this.db.ref("/Numeradores").set(Numeradores);
    return "alta Numeradores";
  }

  altaEvaluacion(Evaluacion) {
    this.db.ref("/Evaluacion").set(Evaluacion);
    return "alta evaluacion";
  }

  altaRoles(Roles) {
    Roles.forEach((r) => {
      this.db.ref(`/Roles/${r.rol}`).set(r);
    });
    return "alta roles";
  }

  altaCategorias(Cat) {
    this.db.ref("/Categorias").set(Cat);
    return "alta categorias";
  }

  altaEV(Ev) {
    Ev.forEach((e) => {
      this.db.ref("/EarnValue/").child(e.id).set(e);
    });
    return "alta earnedvalue";
  }
}

export default Firebase;
